import styled from 'styled-components';

export const Root = styled.div`
  background: #f2f1f1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
`;

export const Content = styled.div`
  box-sizing: border-box;
  column-gap: 16px;
  display: grid;
  grid-template-columns: 19% 39% 40%;
  margin-top: 27vh;
  padding: 0 16px;
  width: 100%;
`;
